import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import { api } from '../../services/api'
import { validateEmail } from '../../utils/validation'
import {
  AuthContainer,
  AuthCard,
  Form,
  ButtonContainer,
  Divider,
  BackText,
  StyledLink,
  InputGroup,
  Label,
  StyledInput,
  ErrorText,
} from './styles'

export function ResendVerification() {
  const location = useLocation()
  const [email, setEmail] = useState('')
  const [touched, setTouched] = useState({})
  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [justRegistered, setJustRegistered] = useState(false)

  useEffect(() => {
    if (location.state?.email) {
      setEmail(location.state.email)
    }
    if (location.state?.justRegistered) {
      setJustRegistered(true)
    }
  }, [location])

  const validateField = (name, value) => {
    let error = ''

    if (name === 'email') {
      if (!value) {
        error = 'Email é obrigatório'
      } else if (!validateEmail(value)) {
        error = 'Email inválido'
      }
    }

    setErrors((prev) => ({ ...prev, [name]: error }))
    return !error
  }

  const onBlur = (name) => {
    setTouched((prev) => ({ ...prev, [name]: true }))
    if (name === 'email') validateField(name, email)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    setTouched({ email: true })
    const emailValid = validateField('email', email)

    if (!emailValid) {
      return
    }

    setIsLoading(true)

    try {
      await api.post('/auth/resend-verification', { email })
      setSubmitted(true)
      toast.success('Email de verificação reenviado com sucesso!')
    } catch (error) {
      if (error.response?.status === 400 && error.response.data?.message?.includes('já verificado')) {
        toast.info('Este email já foi verificado. Você pode fazer login.')
        setSubmitted(true)
      } else {
        toast.success('Se o email estiver cadastrado, você receberá um novo link de verificação.')
        setSubmitted(true)
      }
    } finally {
      setIsLoading(false)
    }
  }

  const isFormValid = !errors.email && email

  if (submitted) {
    return (
      <AuthContainer>
        <AuthCard>
          <h1>Email Enviado</h1>
          <p>Se o email informado estiver cadastrado e não verificado, você receberá um novo link de verificação.</p>
          <p>Verifique sua caixa de entrada e spam.</p>

          <Divider />

          <BackText>
            <StyledLink to="/login">Voltar para Login</StyledLink>
          </BackText>
        </AuthCard>
      </AuthContainer>
    )
  }

  return (
    <AuthContainer>
      <AuthCard>
        <h1>{justRegistered ? 'Verifique seu Email' : 'Reenviar Verificação'}</h1>
        <p>
          {justRegistered
            ? 'Um email de verificação foi enviado para o endereço cadastrado. Verifique sua caixa de entrada e spam.'
            : 'Digite seu email para receber um novo link de verificação'}
        </p>

        <Form onSubmit={handleSubmit}>
          <InputGroup>
            <Label htmlFor="email">Email</Label>
            <StyledInput
              id="email"
              name="email"
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value)
                if (touched.email) validateField('email', e.target.value)
              }}
              onBlur={() => onBlur('email')}
              placeholder="seu@email.com"
              autoComplete="email"
              $hasError={touched.email && errors.email}
              $isValid={touched.email && !errors.email && email}
            />
            {touched.email && errors.email && <ErrorText>✗ {errors.email}</ErrorText>}
          </InputGroup>

          <ButtonContainer>
            <button type="submit" disabled={!isFormValid || isLoading}>
              {isLoading ? 'Enviando...' : 'Reenviar Email'}
            </button>
          </ButtonContainer>
        </Form>

        <Divider />

        <BackText>
          <StyledLink to="/login">Voltar para Login</StyledLink>
        </BackText>
      </AuthCard>
    </AuthContainer>
  )
}
